import React from 'react';

import Typography from '@components/typography';
import Icon from '@components/icon/icon';
import Tooltip from '@components/tooltip';
import { v4 as uuid4 } from 'uuid';

import '@styles/customise/sidebar.scss';

import { ColourSelectionProps } from 'interface';

const Option: React.FC<ColourSelectionProps> = ({
  id,
  type,
  title,
  monthlyRentalCost,
  canRemove,
  clickRemoveHandler,
  removeText,
}) => {
  const monthlyRentalCostLabel = `${monthlyRentalCost}pm`;
  const typeLabel = `${type}:`;

  return (
    <div className="selected-options__colours">
      <div className="selection__label">
        <div className="selection__label-name">
          <Typography variant="caption" size="rg">
            {typeLabel}
          </Typography>
        </div>
        <div className="selection__label-title">
          <Typography variant="caption" size="rg">
            {title}
          </Typography>
        </div>
      </div>
      <Typography className="selection__price" variant="caption" size="sm">
        {monthlyRentalCostLabel}
      </Typography>
      {canRemove ? (
        <div className="selection__icon">
          <button
            type="button"
            className="selection__link"
            onClick={() => clickRemoveHandler(id)}
            aria-label={`Remove ${title}`}
            title={`Remove ${title}`}
          >
            <Icon width="24px" height="24px" name="close-circle" />
          </button>
        </div>
      ) : (
        removeText && (
          <Tooltip id={uuid4()} text={''} delayHide={100}>
            <Typography variant="caption" size="xs" colour="alternative">
              {removeText}
            </Typography>
          </Tooltip>
        )
      )}
    </div>
  );
};

export default Option;
